import SectionHeading from '@/components/base/SectionHeading';
import { aboutImages, principles, philosophy } from '@/mocks/about';

export function AboutHero() {
  return (
    <section className="px-4 md:px-6 lg:px-20 pt-10 md:pt-16 pb-16 md:pb-20">
      <div className="max-w-content mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:items-end fade-up">
          <div className="lg:col-span-7">
            <p className="text-xs md:text-[13px] font-medium tracking-[0.14em] text-secondary-500 mb-4">ABOUT CLEARY</p>
            <h1 className="font-heading text-[38px] md:text-[56px] lg:text-[64px] leading-[1.06] font-medium tracking-tight">A Little More Care in Every Clean.</h1>
          </div>
          <p className="lg:col-span-4 lg:col-start-9 text-base md:text-lg leading-[1.6] text-foreground-600">We believe a well-cared-for home makes everyday life feel lighter, calmer and more comfortable.</p>
        </div>
        <div data-reveal="image" className="mt-10 md:mt-14 w-full h-[280px] md:h-[440px] lg:h-[560px] rounded-[24px] overflow-hidden bg-background-200">
          <img loading="eager" fetchPriority="high" src={aboutImages.hero} alt="CLEARY cleaner tidying a bright living room" title="About CLEARY home cleaning" className="w-full h-full object-cover object-top" />
        </div>
      </div>
    </section>
  );
}

export function AboutApproach() {
  return (
    <section className="px-4 md:px-6 lg:px-20 py-16 md:py-20 lg:py-[112px] bg-background-100">
      <div className="max-w-content mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-20 items-center">
        <div data-reveal="image" className="w-full h-[400px] md:h-[520px] lg:h-[640px] rounded-[20px] overflow-hidden bg-background-200">
          <img loading="lazy" decoding="async" src={aboutImages.approach} alt="Careful surface wiping in a home" title="CLEARY cleaning approach" className="w-full h-full object-cover object-top" />
        </div>
        <div>
          <SectionHeading eyebrow="OUR APPROACH" title="Cleaning with Care and Intention." />
          <ol data-reveal-group className="mt-10 border-t border-background-300">
            {principles.map((p) => (
              <li key={p.num} className="flex gap-5 py-6 border-b border-background-300">
                <span className="text-sm font-medium text-secondary-500 pt-1">{p.num}</span>
                <div>
                  <h3 className="font-heading text-[20px] lg:text-[22px] font-medium">{p.title}</h3>
                  <p className="mt-2 text-[15px] md:text-base leading-[1.6] text-foreground-600">{p.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export function AboutPeople() {
  return (
    <section className="px-4 md:px-6 lg:px-20 py-16 md:py-20 lg:py-[112px]">
      <div className="max-w-content mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:items-end">
          <div className="lg:col-span-6"><SectionHeading eyebrow="THE PEOPLE BEHIND THE CLEAN" title="People Make the Difference." /></div>
          <p className="lg:col-span-5 lg:col-start-8 text-base md:text-lg leading-[1.6] text-foreground-600">Good cleaning comes down to people who show up prepared, pay attention and treat every home with respect. Professionalism and everyday care guide how our team works in each space.</p>
        </div>
        <div data-reveal="image" className="mt-10 md:mt-14 w-full h-[260px] md:h-[420px] lg:h-[520px] rounded-[24px] overflow-hidden bg-background-200">
          <img loading="lazy" decoding="async" src={aboutImages.team} alt="CLEARY cleaning professionals preparing supplies" title="CLEARY cleaning team" className="w-full h-full object-cover object-top" />
        </div>
      </div>
    </section>
  );
}

export function AboutPhilosophy() {
  return (
    <section className="px-4 md:px-6 lg:px-20 py-16 md:py-20 lg:py-[112px] bg-background-100">
      <div className="max-w-content mx-auto">
        <SectionHeading eyebrow="OUR SERVICE PHILOSOPHY" title="Small Habits, Better Results." />
        <div data-reveal-group className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-background-300">
          {philosophy.map((v, i) => (
            <div key={v.title} className={`py-8 lg:pr-8 ${i > 0 ? 'lg:pl-8 lg:border-l border-background-300' : ''}`}>
              <span className={`block w-2 h-2 rounded-full ${i === 0 ? 'bg-accent-500' : 'bg-secondary-500'}`} />
              <h3 className="mt-5 text-base md:text-lg font-medium">{v.title}</h3>
              <p className="mt-2 text-[15px] leading-[1.6] text-foreground-600">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}